import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import PageHeader from 'app/components/PageHeader';
import { btnStatusPayment } from './PaymentOrdersPage.sx';
import usePaymentOrdersPage from './usePaymentOrdesPage';
import PaymentOrdersTable from './PaymentOrdersTable';
import {grayFilter} from "app/components/ThemeProvider/colors";

const PaymentOrdersPage = () => {
  const { btnId, setBtnId, tableHeader, dataTaxOrders, isLoadingTaxOrders, handleGetFiles } = usePaymentOrdersPage();

  const filterBtns = [
    { id: 1, title: 'Hamısı', name: 'Hamısı' },
    { id: 2, title: 'Dondurulmali', name: 'Dondurulmalı' },
    { id: 3, title: 'Alinmali', name: 'Alınmalı' },
  ];

  if (isLoadingTaxOrders) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <Box>
        <PageHeader pageName={'Sərəncamlar'} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', marginTop: '28px' }}>
          <Box sx={{ display: 'flex', gap: '8px' }}>
            {filterBtns.map((item, index) => (
              <Button
                key={item.id}
                color={'tertiary'}
                size={'medium'}
                sx={
                  btnId === item.id
                    ? { ...btnStatusPayment, background: grayFilter, boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)' }
                    : btnStatusPayment
                }
                onClick={() => setBtnId(item.id)}
              >
                {item.name}
              </Button>
            ))}
          </Box>
          {/*<Filter pageName={'payment-orders'} bg={true} />*/}
        </Box>
        <PaymentOrdersTable
          tableHeader={tableHeader}
          tableRow={
            btnId === 1
              ? dataTaxOrders.tax_orders
              : btnId === 2
              ? dataTaxOrders.tax_orders.filter((item) => item.type === 'D')
              : dataTaxOrders.tax_orders.filter((item) => item.type === 'A')
          }
          getFile={handleGetFiles}
        />
      </Box>
    );
  }
};

export default PaymentOrdersPage;
